/**
 * Resources primary — Dispatch Register only.
 * Native desk owns people / robots / drones. No Response embeds. Soft≠Live.
 */
import { useEffect } from "react";
import { html, stay } from "./ui.js";
import ResourcesRegisterDesk from "./resources-register-desk.js";

const KINDS = ["people", "robots", "drones"];

export default function DispatchPrimary({ sub, toast }) {
  const kind = KINDS.includes(sub) ? sub : "people";
  useEffect(() => {
    if (sub === "overview" || !KINDS.includes(sub)) {
      stay("/dispatch/people");
    }
  }, [sub]);

  return html`<${ResourcesRegisterDesk} sub=${kind} toast=${toast}/>`;
}
